import React from "react";
import { CONFIG } from "../../config/keys";
import axios from "axios";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { Link } from "react-router-dom";

import Spinner from "../app/Spinner";
import Modal from "../app/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faPen,
  faPlus,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import NumberFormat from "react-number-format";

import GroupForm from "./GroupForm";
import GroupDelete from "./GroupDelete";
import ProductForm from "./ProductForm";

import "./MenuEdit.css";
import "./ProductList.css";

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      form: null,
      initialValues: [],
      isLoading: true,
      modalLoading: false,
      modalOpen: false,
      groupSelected: this.props.match.params.groupID,
      groupData: [],
      groupName: "",
      productSelected: [],
      productSelectedData: [],
      products: [],
      productName: "",
      productPrice: "",
      sortOptionSelected: [],
      sortOptions: [],
      sortOptionData: [],
      strainTypeSelected: [],
      strainTypes: [],
      strainTypeData: [],
      user: this.props.auth.googleId
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseReload = this.handleCloseReload.bind(this);
    this.handleCloseReloadProducts = this.handleCloseReloadProducts.bind(this);
  }

  componentDidMount() {
    this.props.fetchUser();
    this.props.fetchBrands(localStorage.getItem("SubscriptionId"));
    this.props.fetchCategories(localStorage.getItem("SubscriptionId"));
    this.props.fetchSortOptions();
    this.props.fetchStrainTypes();
    this.props.fetchTerpeneProfiles(localStorage.getItem("SubscriptionId"));
    this.loadGroup();
    this.loadProducts();
  }

  handleOpen() {
    this.setState({ modalOpen: true });
  }

  handleClose() {
    this.setState({ modalOpen: false });
  }

  handleCloseReload = () => {
    this.setState({ modalOpen: false });
    this.loadGroup();
  };

  handleCloseReloadProducts = () => {
    this.setState({ modalOpen: false });
    this.loadProducts();
  };

  handleCloseReloadMenus = () => {
    this.setState({ modalOpen: false });
    this.props.history.push("/menus/groups");
  };

  loadGroup() {
    this.setState({
      isLoading: true
    });

    const ApiGroupQuery =
      "/Group(" +
      this.state.groupSelected +
      ")?$select=Name,Oid,Type,SortOption,HalfGramPrice,GramPrice,EighthPrice,QuarterPrice,HalfPrice,OzPrice&$expand=SortOption&$format=json";
    axios({
      method: "get",
      url: CONFIG.API_URL + ApiGroupQuery,
      headers: {
        "Content-Type": "application/json",
        Auth: CONFIG.API_KEY
      }
    })
      .then(result =>
        this.setState({
          groupData: result.data.d,
          sortOptionSelected: result.data.d.SortOption,
          isLoading: false
        })
      )
      .catch(error =>
        this.setState({
          error,
          isLoading: false
        })
      );
  }

  loadProducts() {
    const ApiThemesQuery = `/Product?$filter=Group/Oid eq ${this.state.groupSelected}&$orderby=Name&$select=Oid,Name,Price,SalePrice,InStock,Brand,Brand/ColorCode/ColorCode,Category,Category/ColorCode/ColorCode,Group,StrainType,StrainType/ColorCode/ColorCode,TerpeneProfile,TerpeneProfile/ColorCode/ColorCode&$expand=Brand,Brand/ColorCode,Category,Category/ColorCode,Group,StrainType,StrainType/ColorCode,TerpeneProfile,TerpeneProfile/ColorCode&$format=json`;
    axios({
      method: "get",
      url: CONFIG.API_URL + ApiThemesQuery,
      headers: {
        "Content-Type": "application/json",
        Auth: CONFIG.API_KEY
      }
    })
      .then(result => {
        //console.log("Results Found");
        //console.log(result.data.d.length);
        this.setState({
          products: result.data.d
        });
      })
      .catch(error =>
        this.setState({
          error
        })
      );
  }

  render() {
    const RenderPlaceholder = () => {
      return <Spinner />;
    };
    const RenderContent = props => {
      let sortOption = "Sort Options";
      // let pricingType = "Pricing Type";
      if (this.state.sortOptionSelected !== null) {
        if (this.state.sortOptionSelected.Name !== undefined) {
          sortOption = "Sort by: " + this.state.sortOptionSelected.Name;
        }
      }
      // if (this.state.groupData.Type !== null) {
      //   pricingType = "Pricing: " + this.state.groupData.Type;
      // }
      let deleteButton = "";
      if (localStorage.getItem("UserIsAdmin") === "true") {
        deleteButton = (
          <button
            className="waves-effect waves-light btn"
            onMouseDown={handleDeleteGroup}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" /> Delete
          </button>
        );
      }
      return (
        <div>
          <Link className="waves-effect waves-light btn" to="/menus/groups">
            <FontAwesomeIcon icon={faChevronLeft} size="lg" /> Back to Groups
          </Link>
          <div className="component-group">
            <h1>{props.title}</h1>
            <div className="component-actions">
              <button
                className="waves-effect waves-light btn"
                onMouseDown={handleEditGroup}
              >
                <FontAwesomeIcon icon={faPen} size="lg" /> Edit
              </button>
              &nbsp;
              {deleteButton}
            </div>
            <div className="panel-container component-shadow">
              <div className="panel-header">
                <div className="panel-title">{sortOption}</div>
                <div className="panel-actions">
                  <button
                    className="waves-effect waves-light btn btn-small"
                    onMouseDown={handleAddProduct}
                  >
                    <FontAwesomeIcon icon={faPlus} size="lg" /> Add Product
                  </button>
                </div>
              </div>
              <div className="panel-content">
                {renderProducts(this.state.products, this.state.groupSelected)}
              </div>
            </div>
          </div>
        </div>
      );
    };

    // ***************************
    // RENDER PRODUCTS
    const renderProducts = (products, group) => {
      let sourceData = [];

      // DEFAULT SORT BY NAME
      products = products.sort(function(a, b) {
        // set default to last letter possible
        var valueA = "ZZZ";
        var valueB = "ZZZ";
        if (a.Name) {
          valueA = a.Name.toUpperCase();
        }
        if (b.Name) {
          valueB = b.Name.toUpperCase();
        }
        if (valueA < valueB) {
          return -1;
        }
        if (valueA > valueB) {
          return 1;
        }
        // names must be equal
        return 0;
      });

      // SORT BY BRAND
      if (this.state.sortOptionSelected !== null) {
        if (this.state.sortOptionSelected.Type === "brand") {
          products = products.sort(function(a, b) {
            // set default to last letter possible
            var valueA = "ZZZ";
            var valueB = "ZZZ";
            if (a.Brand !== null && a.Brand.Name !== "NA") {
              valueA = a.Brand.Name.toUpperCase(); // ignore upper and lowercase
            }
            if (b.Brand !== null && b.Brand.Name !== "NA") {
              valueB = b.Brand.Name.toUpperCase(); // ignore upper and lowercase
            }
            if (valueA < valueB) {
              return -1;
            }
            if (valueA > valueB) {
              return 1;
            }
            // names must be equal
            return 0;
          });
        }
      }

      // SORT BY CATEGORY
      if (this.state.sortOptionSelected !== null) {
        if (this.state.sortOptionSelected.Type === "category") {
          products = products.sort(function(a, b) {
            // set default to last letter possible
            var valueA = "ZZZ";
            var valueB = "ZZZ";
            if (a.Category !== null && a.Category.Name !== "NA") {
              valueA = a.Category.Name.toUpperCase(); // ignore upper and lowercase
            }
            if (b.Category !== null && b.Category.Name !== "NA") {
              valueB = b.Category.Name.toUpperCase(); // ignore upper and lowercase
            }
            if (valueA < valueB) {
              return -1;
            }
            if (valueA > valueB) {
              return 1;
            }
            // names must be equal
            return 0;
          });
          // console.log(products);
        }
      }

      // SORT BY STRAIN TYPE
      if (this.state.sortOptionSelected !== null) {
        if (this.state.sortOptionSelected.Type === "strain") {
          products = products.sort(function(a, b) {
            var valueA = "ZZZ";
            var valueB = "ZZZ";
            if (a.StrainType !== null && a.StrainType.Name !== "NA") {
              valueA = a.StrainType.Name.toUpperCase(); // ignore upper and lowercase
            }
            if (b.StrainType !== null && b.StrainType.Name !== "NA") {
              valueB = b.StrainType.Name.toUpperCase(); // ignore upper and lowercase
            }
            switch (valueA) {
              case "INDICA":
                valueA = "1 INDICA";
                break;
              case "SATIVA":
                valueA = "2 SATIVA";
                break;
              case "HYBRID":
                valueA = "3 HYBRID";
                break;
              case "CBD":
                valueA = "4 CBD";
                break;
              default:
                valueA = "5 NONE";
            }
            switch (valueB) {
              case "INDICA":
                valueB = "1 INDICA";
                break;
              case "SATIVA":
                valueB = "2 SATIVA";
                break;
              case "HYBRID":
                valueB = "3 HYBRID";
                break;
              case "CBD":
                valueB = "4 CBD";
                break;
              default:
                valueB = "5 NONE";
            }
            if (valueA < valueB) {
              return -1;
            }
            if (valueA > valueB) {
              return 1;
            }
            // names must be equal
            return 0;
          });
        }
      }

      // SORT BY TERPENE PROFILE
      if (this.state.sortOptionSelected !== null) {
        if (this.state.sortOptionSelected.Type === "terpene") {
          products = products.sort(function(a, b) {
            var valueA = "ZZZ";
            var valueB = "ZZZ";
            if (a.TerpeneProfile !== null && a.TerpeneProfile.Name !== "NA") {
              valueA = a.TerpeneProfile.Name.toUpperCase(); // ignore upper and lowercase
            }
            if (b.TerpeneProfile !== null && b.TerpeneProfile.Name !== "NA") {
              valueB = b.TerpeneProfile.Name.toUpperCase(); // ignore upper and lowercase
            }
            if (valueA < valueB) {
              return -1;
            }
            if (valueA > valueB) {
              return 1;
            }
            // names must be equal
            return 0;
          });
        }
      }

      for (let i = 0; i < products.length; i++) {
        //console.log(this.state.sortOptionSelected.Type);
        if (
          products[i].Group !== null &&
          products[i].Group.Oid === parseInt(group)
        ) {
          // console.log(products[i]);
          let price = "";
          if (products[i].SalePrice > 0) {
            price = (
              <div>
                <NumberFormat
                  displayType={"text"}
                  value={products[i].Price}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix={"$"}
                  className="txt-strike txt-inactive"
                />
                <br />
                <NumberFormat
                  displayType={"text"}
                  value={products[i].SalePrice}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix={"$"}
                />
              </div>
            );
          } else {
            price = (
              <div>
                <NumberFormat
                  displayType={"text"}
                  value={products[i].Price}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix={"$"}
                />
              </div>
            );
          }
          let itemStyle = {
            borderLeft: "4px solid rgba(158, 158, 158, .5)"
          };
          if (
            this.state.sortOptionSelected.Type === "brand" &&
            products[i].Brand !== null
          ) {
            itemStyle = {
              borderLeft:
                "4px solid rgba(" +
                products[i].Brand.ColorCode.ColorCode +
                ",.5)"
            };
          }
          if (
            this.state.sortOptionSelected.Type === "category" &&
            products[i].Category !== null
          ) {
            itemStyle = {
              borderLeft:
                "4px solid rgba(" +
                products[i].Category.ColorCode.ColorCode +
                ",.5)"
            };
          }
          if (
            this.state.sortOptionSelected.Type === "strain" &&
            products[i].StrainType !== null
          ) {
            itemStyle = {
              borderLeft:
                "4px solid rgba(" +
                products[i].StrainType.ColorCode.ColorCode +
                ",.5)"
            };
          }
          if (
            this.state.sortOptionSelected.Type === "terpene" &&
            products[i].TerpeneProfile !== null
          ) {
            itemStyle = {
              borderLeft:
                "4px solid rgba(" +
                products[i].TerpeneProfile.ColorCode.ColorCode +
                ",.5)"
            };
          }
          let strain = "";
          let strainStyle = { color: "grey", display: "none" };
          if (
            this.state.sortOptionSelected.Type === "name" ||
            this.state.sortOptionSelected.Type === "strain"
          ) {
            strain = <div className="txt-inactive">No Strain Type</div>;
            if (products[i].StrainType && products[i].StrainType.Oid !== 1) {
              if (products[i].StrainType.ColorCode) {
                strainStyle = {
                  color:
                    "rgba(" + products[i].StrainType.ColorCode.ColorCode + ",1)"
                };
              }
              strain = (
                <div style={strainStyle}>{products[i].StrainType.Name}</div>
              );
            }
          }

          let brand = "";
          let brandStyle = { color: "grey", display: "none" };
          if (this.state.sortOptionSelected.Type === "brand") {
            brand = <div className="txt-inactive">No Brand</div>;
            if (products[i].Brand && products[i].Brand.Oid !== 1) {
              if (
                products[i].Brand.ColorCode &&
                this.state.sortOptionSelected.Type === "brand"
              ) {
                brandStyle = {
                  color: "rgba(" + products[i].Brand.ColorCode.ColorCode + ",1)"
                };
              }
              brand = <div style={brandStyle}>{products[i].Brand.Name}</div>;
            }
          }

          let category = "";
          let categoryStyle = { color: "grey", display: "none" };
          if (this.state.sortOptionSelected.Type === "category") {
            category = <div className="txt-inactive">No Category</div>;
            if (products[i].Category && products[i].Category.Oid !== 1) {
              if (products[i].Category.ColorCode) {
                categoryStyle = {
                  color:
                    "rgba(" + products[i].Category.ColorCode.ColorCode + ",1)"
                };
              }
              category = (
                <div style={categoryStyle}>{products[i].Category.Name}</div>
              );
            }
          }

          let terpene = "";
          let terpeneStyle = { color: "grey", display: "none" };
          if (this.state.sortOptionSelected.Type === "terpene") {
            terpene = <div className="txt-inactive">No Terpene Profile</div>;
            if (
              products[i].TerpeneProfile &&
              products[i].TerpeneProfile.Oid !== 1
            ) {
              if (products[i].TerpeneProfile.ColorCode) {
                terpeneStyle = {
                  color:
                    "rgba(" +
                    products[i].TerpeneProfile.ColorCode.ColorCode +
                    ",1)"
                };
              }
              terpene = (
                <div style={terpeneStyle}>
                  {products[i].TerpeneProfile.Name}
                </div>
              );
            }
          }
          sourceData.push(
            <div key={products[i].Name + i} className="item" style={itemStyle}>
              <div className="item-details">
                <div className="item-name">
                  {products[i].Name}
                  {brand}
                  {category}
                  {strain}
                  {terpene}
                </div>
              </div>
              <div className="item-price txt-left">{price}</div>
              <div className="panel-actions">
                <button
                  className="waves-effect waves-light btn btn-small"
                  onMouseDown={handleEditProduct}
                  id={products[i].Oid}
                >
                  <FontAwesomeIcon icon={faPen} size="lg" />
                </button>
                &nbsp;
                <button
                  className="waves-effect waves-light btn btn-small"
                  onMouseDown={handleDeleteProduct}
                  id={products[i].Oid}
                >
                  <FontAwesomeIcon icon={faTrash} size="lg" />
                </button>
              </div>
            </div>
          );
        }
      }
      return sourceData;
    };

    // ***************************
    // EDIT GROUP FUNCTIONALITY
    const handleEditGroup = e => {
      this.setState({
        form: "edit-group",
        modalOpen: true,
        groupName: this.state.groupData.Name
      });
    };

    // ***************************
    // DELETE GROUP FUNCTIONALITY
    const handleDeleteGroup = e => {
      this.setState({ form: "delete-group", modalOpen: true });
    };

    // ***************************
    // ADD PRODUCT FUNCTIONALITY
    const handleAddProduct = () => {
      this.setState({
        form: "add-product",
        modalOpen: true
      });
    };

    // ***************************
    // EDIT PRODUCT FUNCTIONALITY
    const handleEditProduct = e => {
      var selectedProduct = this.state.products.find(
        element => element.Oid === parseInt(e.currentTarget.id)
      );
      //console.log(selectedProduct.StrainType.Name);
      //console.log(selectedProduct.StrainType.Oid);
      let selectedStrainType = null;
      if (selectedProduct.StrainType !== null) {
        selectedStrainType = {
          value: selectedProduct.StrainType.Oid,
          label: selectedProduct.StrainType.Name
        };
      }
      // console.log(selectedStrainType);
      this.setState({
        productSelected: e.currentTarget.id,
        productSelectedData: selectedProduct,
        strainTypeSelected: selectedStrainType,
        form: "edit-product",
        modalOpen: true
      });
    };

    // ***************************
    // DELETE PRODUCT FUNCTIONALITY
    const handleDeleteProduct = e => {
      this.setState({
        productSelected: e.currentTarget.id,
        form: "delete-product",
        modalOpen: true
      });
    };
    const renderDeleteProductForm = () => {
      var selectedProduct = this.state.products.find(
        element => element.Oid === parseInt(this.state.productSelected)
      );
      // console.log(selectedProduct);
      return (
        <div className="txt-center">
          <div>Are you sure you want to delete?</div>
          <div>
            <h4>{selectedProduct.Name}</h4>
          </div>
          <button
            className="waves-effect waves-light btn"
            onMouseDown={handleDeleteProductSubmitted}
            id={this.state.productSelected}
          >
            Confirm
          </button>
          &nbsp;
          <button
            className="waves-effect waves-light btn"
            onMouseDown={this.handleClose}
          >
            Cancel
          </button>
        </div>
      );
    };
    const handleDeleteProductSubmitted = e => {
      this.setState({
        modalLoading: true
      });
      const DeleteGroupQuery = "/Product(" + parseInt(e.currentTarget.id) + ")";
      axios({
        method: "delete",
        url: CONFIG.API_URL + DeleteGroupQuery,
        headers: {
          "Content-Type": "application/json",
          Auth: CONFIG.API_KEY
        }
      })
        .then(result => {
          this.setState({
            form: null,
            modalLoading: false
          });
          this.handleClose();
          this.loadProducts();
        })
        .catch(error => console.log(error));
    };

    const renderForm = type => {
      switch (type) {
        case "edit-group":
          // return renderEditForm();
          return (
            <div>
              <GroupForm
                id={this.state.groupData.Oid}
                data={this.state.groupData}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
                sortOptions={this.props.sortOptions}
                SubscriptionId={localStorage.getItem("SubscriptionId")}
              />
            </div>
          );
        case "delete-group":
          // return renderDeleteForm();
          return (
            <div>
              <GroupDelete
                id={this.state.groupData.Oid}
                data={this.state.groupData}
                handleClose={this.handleClose}
                handleCloseReloadMenus={this.handleCloseReloadMenus}
              />
            </div>
          );
        case "add-product":
          // return renderAddProductForm();
          return (
            <div>
              <ProductForm
                id=""
                group={this.state.groupData}
                data=""
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReloadProducts}
                brands={this.props.brands}
                categories={this.props.categories}
                strainTypes={this.props.strainTypes}
                terpeneProfiles={this.props.terpeneProfiles}
                SubscriptionId={localStorage.getItem("SubscriptionId")}
              />
            </div>
          );
        case "edit-product":
          return (
            <div>
              <ProductForm
                id={this.state.productSelected}
                group={this.state.groupData}
                data={this.state.productSelectedData}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReloadProducts}
                brands={this.props.brands}
                categories={this.props.categories}
                strainTypes={this.props.strainTypes}
                terpeneProfiles={this.props.terpeneProfiles}
                SubscriptionId={localStorage.getItem("SubscriptionId")}
              />
            </div>
          );
        case "delete-product":
          return renderDeleteProductForm();
        default:
          return RenderPlaceholder();
      }
    };

    return (
      <div
        className={
          "component-group-edit pad-20 show-" +
          this.state.groupData.Type +
          "-pricing"
        }
      >
        {this.state.isLoading ? (
          <RenderPlaceholder />
        ) : (
          <RenderContent title={this.state.groupData.Name} />
        )}
        <Modal modalOpen={this.state.modalOpen}>
          {renderForm(this.state.form, this.state.groupData)}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    brands: state.brands,
    categories: state.categories,
    sortOptions: state.sortOptions,
    strainTypes: state.strainTypes,
    terpeneProfiles: state.terpeneProfiles
  };
}

export default connect(
  mapStateToProps,
  actions
)(Component);
